import { render, staticRenderFns } from "./upsertClient.vue?vue&type=template&id=234a861c&"
import script from "./upsertClient.vue?vue&type=script&lang=js&"
export * from "./upsertClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports